import { ref, computed } from 'vue-demi';
import useStore from '@/platform/composables/useStore';
import useCurrentRoute from '@/platform/composables/useCurrentRoute';
import PassiveHelpers from '../../data/passive-help/PassiveHelpers';

const showPassiveHelpPanel = ref(false);
const activePassiveHelpId = ref(null);

export default function usePassiveHelp() {
  const store = useStore();
  const currentRoute = useCurrentRoute();

  const isCurrentRoutePassiveHelpEnabled = computed(() => {
    const isPassiveHelpable = Object.values(PassiveHelpers).find((ph) =>
      currentRoute.value?.path[ph.matchIncludes ? 'includes' : 'endsWith'](
        ph.route,
      ),
    );
    return !!isPassiveHelpable;
  });

  const currentPassiveHelp = computed(() => {
    const matchedPassiveHelper = Object.values(PassiveHelpers).find((ph) =>
      currentRoute.value?.path[ph.matchIncludes ? 'includes' : 'endsWith'](
        ph.route,
      ),
    );
    if (!matchedPassiveHelper) {
      return [];
    }
    return matchedPassiveHelper;
  });

  function setActivePassiveHelpId(newPassiveHelpId) {
    activePassiveHelpId.value = newPassiveHelpId;
  }

  function changePassiveHelpPanelStatus(status) {
    showPassiveHelpPanel.value = status;
  }

  const isPassiveHelpPanelEnabled = computed(() => {
    return showPassiveHelpPanel.value;
  });

  async function dismissPassiveHelpById(id) {
    const passiveHelpersDismissed = [
      ...store.state.preferences.user.passiveHelpersDismissed,
      id,
    ];

    store.commit('preferences/change', {
      prefs: {
        passiveHelpersDismissed,
      },
      scope: 'user',
    });

    await store.dispatch('preferences/persist', {
      prefs: {
        passiveHelpersDismissed,
      },
      scope: 'user',
    });
  }

  const isCurrentPassiveHelpDismissed = computed(() => {
    return store.state.preferences.user.passiveHelpersDismissed.includes(
      currentPassiveHelp.value.id,
    );
  });

  return {
    activePassiveHelpId,
    setActivePassiveHelpId,
    isCurrentPassiveHelpDismissed,
    isPassiveHelpPanelEnabled,
    changePassiveHelpPanelStatus,
    currentRoute,
    currentPassiveHelp,
    isCurrentRoutePassiveHelpEnabled,
    dismissPassiveHelpById,
  };
}
